import { onBeforeMount, onBeforeUnmount, onMounted } from 'vue';
import store from '@/store';
import {
  SET_DEVICE,
  SET_COLLAPSE_STATUS,
} from '@/store/actionTypes';

const _width = 992;
export const useResize = () => {
  const isMobile = () => {
    const rect = document.body.getBoundingClientRect();
    return rect.width - 1 < _width;
  };

  const setDevice = () => (store.commit(`app/${SET_DEVICE}`, isMobile() ? 'mobile' : 'desktop'));

  const setCollapseStatus = () => {
    const mobile = isMobile();
    if (mobile) {
      store.commit(`app/${SET_COLLAPSE_STATUS}`, true);
    } else {
      store.commit(`app/${SET_COLLAPSE_STATUS}`, false);
    }
  };

  const resizeHandler = () => {
    if (!document.hidden) {
      setDevice();
      setCollapseStatus();
    }
  };
  // 隐藏自适应
  // onBeforeMount(() => {
  //   window.addEventListener('resize', resizeHandler);
  // });
  // onBeforeUnmount(() => {
  //   window.removeEventListener('resize', resizeHandler);
  // });
  onMounted(() => {
    setDevice();
    setCollapseStatus();
  });
};
